import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from '@sainsburys-tech/fable'
import { CheckCircle, CrossCircle, InfoCircle } from '@sainsburys-tech/icons'
import { BASKET_API_STATUS } from '@/javascript/hooks/useAddFulfilmentPass'

const ALERT_CONFIGS = {
  [BASKET_API_STATUS.SUCCESS]: {
    message: "You've added Argos Plus to your trolley!",
    status: 'success',
    icon: <CheckCircle />
  },
  [BASKET_API_STATUS.ALREADY_IN_BASKET]: {
    message: 'You already have Argos Plus in your trolley!',
    status: 'info',
    icon: <InfoCircle />
  },
  [BASKET_API_STATUS.ERROR]: {
    message: "Argos Plus couldn't be added to your trolley. Please try again later.",
    status: 'error',
    icon: <CrossCircle />
  }
}

const FulfilmentPassAlert = ({ passStatus }) => {
  const alertConfig = ALERT_CONFIGS[passStatus]

  if (!alertConfig) {
    return null
  }

  return (
    <div className='ds-mb-3'>
      <Alert
        message={alertConfig.message}
        status={alertConfig.status}
        variant='secondary'
        leadingIcon={alertConfig.icon}
      />
    </div>
  )
}

FulfilmentPassAlert.propTypes = {
  passStatus: PropTypes.oneOf(Object.values(BASKET_API_STATUS)).isRequired
}

export default FulfilmentPassAlert
